module.exports = __webpack_public_path__ + "img/01-T.52e2d565.png";